import { json, postBiz, rows } from '../core/coreapi';
import {
  normalizeHistoricalFactRow,
  normalizeHistoricalImportRow,
} from './bieHistorical.normalize';

const SERVICE = 'biehistorical';

export const fetchActivePlanningCycle = async () =>
  json(await postBiz({
    s: 'planningcycle',
    a: 'active',
  }));

export const fetchHistoricalImports = async (filters: any) =>
  rows(await postBiz({
    s: SERVICE,
    a: 'imports',
    //pci: filters.planningcycleid ?? null,
    //scc: filters.scenarioCode ?? null,
    soc: filters.sourceCode ?? null,
    sts: 1,
    pos: filters.page ?? 0,
    plm: filters.pageSize ?? 50,
  })).map(normalizeHistoricalImportRow);

export const fetchHistoricalFacts = async (filters: any) =>
  rows(await postBiz({
    s: SERVICE,
    a: 'facts',
    imi: filters.importid ?? null,
    tri: filters.trackid ?? null,
    fyr: filters.fiscalYear ?? null,
    mtc: filters.metricCode ?? null,
    pdc: filters.productCode ?? null,
    pec: filters.periodCode ?? null,
    pos: filters.page ?? 0,
    plm: filters.pageSize ?? 500,
  })).map(normalizeHistoricalFactRow);

export const saveHistoricalFacts = async (records: any[]) =>
  json(await postBiz({
    s: SERVICE,
    a: 'savefacts',
    rcd: records,
  }));

export const generateHistoricalMatrix = async (params: any) =>
  rows(await postBiz({
    s: SERVICE,
    a: 'matrix',
    mtc: params.metricCode,
    fyr: params.fiscalYear,
    pdc: params.productCodes ?? [],
  })).map(normalizeHistoricalFactRow);

export const downloadHistoricalTemplate = async (params: any) =>
  json(await postBiz({
    s: SERVICE,
    a: 'template',
    mtc: params.metricCode ?? null,
    fyr: params.fiscalYear ?? null,
  }));

export const validateHistoricalWorkbook = async (filePayload: any) =>
  json(await postBiz({
    s: SERVICE,
    a: 'validateworkbook',
    ...filePayload,
  }));

export const importHistoricalWorkbook = async (filePayload: any) =>
  json(await postBiz({
    s: SERVICE,
    a: 'importworkbook',
    ...filePayload,
  }));

export const advanceHistoricalPhase = async (
  planningcycleid: number,
  notes = '',
) =>
  json(await postBiz({
    s: 'planningcycle',
    a: 'advance',
    rid: planningcycleid,
    phc: 'FORECAST_BASELINE',
    nts: notes,
  }));
